<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingVruchtgebruik">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseVruchtgebruik" aria-expanded="false" aria-controls="collapseVruchtgebruik">
                Vruchtgebruik
            </button>
        </h2>
        <div id="collapseVruchtgebruik" class="accordion-collapse collapse" aria-labelledby="headingVruchtgebruik"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij schenking onder voorbehoud van vruchtgebruik behoudt de schenker het recht op gebruik of genot van
                het goed (bijv. huurinkomsten uit vastgoed). De begiftigde krijgt slechts de blote eigendom. Fiscaal
                wordt pas schenkbelasting geheven over het vruchtgebruik bij het vervallen ervan (meestal bij overlijden
                van de vruchtgebruiker).
                <div class="space20"></div>
                De waarde van het vruchtgebruik wordt bepaald aan de hand van de leeftijd van
                de gerechtigde en standaard actuariële tabellen. Dit leidt tot een tweede belastbaar feit. Deze
                constructie vereist zorgvuldige vastlegging en waardering om discussie te voorkomen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingVruchtgebruik1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseVruchtgebruik1" aria-expanded="false"
                    aria-controls="collapseVruchtgebruik1">
                Waarde vruchtgebruik
            </button>
        </h2>
        <div id="collapseVruchtgebruik1" class="accordion-collapse collapse" aria-labelledby="headingVruchtgebruik1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De 'waarde vruchtgebruik' is de waarde van het vruchtgebruik op de dag van de schenking.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingVruchtgebruik2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseVruchtgebruik2" aria-expanded="false"
                    aria-controls="collapseVruchtgebruik2">
                Waarde stamkapitaal
            </button>
        </h2>
        <div id="collapseVruchtgebruik2" class="accordion-collapse collapse" aria-labelledby="headingVruchtgebruik2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De 'waarde stamkapitaal' is de waarde van het geschonken goed dat in stand moet worden gehouden.
                De schenker heeft in zo'n geval als voorwaarde bepaald dat het geschonken vermogen in stand moet blijven,
                of bepaald dat alleen het rendement uit dat vermogen wordt gebruikt om het doel van de begiftigde na te
                streven.
            </div>
        </div>
    </div>
</div>
